export default __webpack_public_path__ + "static/media/hht1_ep9_minisitcom_04.94c65832.png";